import { RootState } from "../../../../system/redux/store/community-finder-redux-store";

export const selectCurrentUnmatchedPage = (state: RootState) =>
	state?.results?.pagination?.currentUnmatchedPage;
